import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "options"];
import { Label } from "./CheckboxOption.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Select = _ref => {
  var children = _ref.children,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Label, {
    children: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx("select", _extends({}, other, {
        children: options.map((item, key) => {
          var isObjectOption = typeof item === 'object' && item !== null;
          var label = isObjectOption ? item.label : item;
          var value = isObjectOption ? item.value : item;
          return /*#__PURE__*/_jsx("option", {
            value: value,
            children: label
          }, key + " " + (value || ''));
        })
      })), /*#__PURE__*/_jsx("span", {
        children: children
      })]
    })
  });
};